import { render } from "./IndividualInformation.vue?vue&type=template&id=8e30ef3c&scoped=true"
import script from "./IndividualInformation.vue?vue&type=script&lang=js"
export * from "./IndividualInformation.vue?vue&type=script&lang=js"

import "./IndividualInformation.vue?vue&type=style&index=0&id=8e30ef3c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e30ef3c"]])

export default __exports__